export const table = {
  wrapper: {
    style: { borderRadius: "8px" },
  },

  header: {
    gap: "middle",
    justify: "space-between",
    wrap: "wrap",
  },

  date: {
    picker: "year",
    allowClear: false,
  },

  addSemesterButton: {
    type: "primary",
  },

  saveButton: {
    type: "primary",
    style: { background: "#0eaf65" },
  },

  // ─── Results Page ──────────────────────────────────────────────

  page: {
    fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
  },

  headerRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 28,
    flexWrap: "wrap",
    gap: 12,
  },

  title: (tok) => ({
    margin: 0,
    fontSize: 20,
    fontWeight: 700,
    color: tok.colorText,
    letterSpacing: "-0.3px",
  }),

  subtitle: (tok) => ({
    margin: "2px 0 0",
    fontSize: 13,
    color: tok.colorTextSecondary,
  }),

  // ─── Score Grid ────────────────────────────────────────────────

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: 16,
    marginBottom: 20,
  },

  scoreCard: (accent, tok) => ({
    background: tok.colorBgContainer,
    border: `1px solid ${accent}33`,
    borderRadius: 14,
    padding: "18px 20px",
    position: "relative",
    overflow: "hidden",
  }),

  scoreTop: (accent) => ({
    width: 36,
    height: 36,
    borderRadius: 10,
    background: `${accent}18`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 18,
    marginBottom: 12,
    border: `1px solid ${accent}30`,
  }),

  scoreLabel: (tok) => ({
    fontSize: 11,
    fontWeight: 600,
    color: tok.colorTextQuaternary,
    textTransform: "uppercase",
    letterSpacing: "0.6px",
    marginBottom: 4,
  }),

  scoreValue: (accent) => ({
    fontSize: 28,
    fontWeight: 800,
    color: accent,
    lineHeight: 1,
    letterSpacing: "-0.5px",
  }),

  scoreUnit: (tok) => ({
    fontSize: 11,
    color: tok.colorTextTertiary,
    marginTop: 4,
  }),

  scoreAccentCorner: (accent) => ({
    position: "absolute",
    top: 0,
    right: 0,
    width: 60,
    height: 60,
    borderRadius: "0 14px 0 60px",
    background: `${accent}10`,
  }),

  barBg: (tok) => ({
    height: 5,
    borderRadius: 99,
    background: tok.colorFillSecondary,
    marginTop: 8,
    overflow: "hidden",
  }),

  barFill: (pct, accent) => ({
    height: "100%",
    width: `${pct}%`,
    borderRadius: 99,
    background: accent,
    transition: "width 0.9s cubic-bezier(.4,0,.2,1)",
  }),

  // ─── Final APA Card ────────────────────────────────────────────

  finalCard: {
    background: "linear-gradient(135deg,#6366f1 0%,#8b5cf6 100%)",
    borderRadius: 16,
    padding: "22px 24px",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 16,
    marginTop: 4,
  },

  finalLabel: {
    fontSize: 13,
    opacity: 0.85,
    marginBottom: 4,
    fontWeight: 500,
  },

  finalValue: {
    fontSize: 40,
    fontWeight: 800,
    letterSpacing: "-1px",
    lineHeight: 1,
  },

  finalBadge: {
    background: "rgba(255,255,255,0.18)",
    borderRadius: 99,
    padding: "6px 16px",
    fontSize: 13,
    fontWeight: 600,
    border: "1px solid rgba(255,255,255,0.25)",
  },

  // ─── Empty State ───────────────────────────────────────────────

  empty: (tok) => ({
    textAlign: "center",
    padding: "48px 0",
    color: tok.colorTextTertiary,
    fontSize: 14,
  }),
};